module.exports = __webpack_public_path__ + "img/alert-modal.262b39d6.svg";